module.exports = __webpack_public_path__ + "img/logo-asst.58296bfc.jpg";